import { NgModule } from '@angular/core';
import { CommaDelimiterDirective } from './comma-delimiter.directive';

@NgModule({
  declarations: [
    CommaDelimiterDirective
  ],
  exports: [
    CommaDelimiterDirective
  ]
})
export class CommaDelimiterModule { }
